import { Button } from '../../primitives/button';
import { toast } from '../../utils/toast';

import type { JSX } from 'react';

interface ButtonClipboardProps extends React.ComponentPropsWithoutRef<typeof Button> {
  label?: string | JSX.Element;
  valueToCopy: string;
}

export function ButtonClipboard({
  label = 'Copiar',
  valueToCopy,
  onClick, // remove callback
  ...props
}: ButtonClipboardProps) {
  return (
    <Button
      title="Copiar al portapapeles"
      onClick={async () => {
        try {
          await navigator?.clipboard?.writeText(valueToCopy);
          toast({
            type: 'success',
            description: <div>Copiado al portapapeles</div>,
          });
        } catch {
          toast({
            type: 'error',
            description: <div>No se pudo copiar al portapapeles</div>,
          });
        }
      }}
      {...props}
    >
      {label}
    </Button>
  );
}
